<div class="report row">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Client ID: </span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 col-lg-2 d-flex justify-content-start">
        <span class="">Client: </span>
      </div>
      <div class="col-9 col-lg-10 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated ml-4">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Phone No.: </span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-lg-4 d-flex justify-content-start">
        <span class="">Date Of Birth: </span>
      </div>
      <div class="col-7 col-lg-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerDateOfBirth }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">ID Type: </span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerIdType }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">ID Number: </span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerIdNumber }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-lg-4 d-flex justify-content-start">
        <span class="">Home Details: </span>
      </div>
      <div class="col-7 col-lg-8 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerHomeAreaDetails }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Products: </span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated my-0 py-0">
          <ul class="my-0 py-0">
            <li *ngIf="itm.productCodes.includes(200)">
              BODABODA LOAN
            </li>
            <li *ngIf="itm.productCodes.includes(300)">TAXI LOAN</li>
            <li *ngIf="itm.productCodes.includes(400)">MICROLOAN</li>
            <li *ngIf="itm.productCodes.includes(100)">SAVINGS</li>
          </ul>
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Status: </span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerStatus }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4" *ngIf="itm.microloanCustomerLoanTenure">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Loan Tenure: </span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.microloanCustomerLoanTenure + ' Day' + (itm.microloanCustomerLoanTenure > 1 ? 's'  : '')}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4" *ngIf="itm.microloanCustomerAccrualDays">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Accrual Days: </span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.microloanCustomerAccrualDays + ' Day' + (itm.microloanCustomerAccrualDays > 1 ? 's' : '')}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4" *ngIf="itm.microloanCustomerLoanInterest">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Interest Rate: </span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.microloanCustomerLoanInterest}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4" *ngIf="itm.microloanCustomerAmortCyle">
    <div class="row">
      <div class="col-7 col-md-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Amortization Cycle: </span>
      </div>
      <div class="col-5 col-md-6 col-lg-7 col-xl-6 justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.microloanCustomerAmortCyle === 1 ? 'DAILY' : itm.microloanCustomerAmortCyle === 2 ? 'WEEKLY' :
          itm.microloanCustomerAmortCyle === 3 ? 'FORTNIGHTLY' : itm.microloanCustomerAmortCyle === 4 ? 'MONTHLY' :
          itm.microloanCustomerAmortCyle === 5 ? 'QUARTERLY' : itm.microloanCustomerAmortCyle === 6 ? 'HALF YEARLY' :
          itm.microloanCustomerAmortCyle === 7 ? 'ANNUALLY' : 'BIANNUALLY' }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4" *ngIf="itm.microloanCustomerAmortType">
    <div class="row">
      <div class="col-7 col-md-6 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Amortization Type: </span>
      </div>
      <div class="col-5 col-md-6 col-lg-7 col-xl-6 justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.microloanCustomerAmortType === 1 ? 'FLAT RATE' : itm.microloanCustomerAmortType === 2 ?
          'REDUCING BALANCE WITH REDUCING INSTALMENT' : 'REDUCING BALANCE WITH CONSTANT INSTALMENT' }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4" *ngIf="itm.interestAccrualMethod">
    <div class="row">
      <div class="col-8 col-md-7 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Accrual Method: </span>
      </div>
      <div class="col-4 col-md-5 col-lg-7 col-xl-6 justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.interestAccrualMethod === 1 ? 'NON-COMPOUND' : 'COMPOUND'}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4" *ngIf="itm.microloanCustomerLoanLimit">
    <div class="row">
      <div class="col-8 col-md-7 col-lg-5 col-xl-6 d-flex justify-content-start">
        <span class="">Loan Limit: </span>
      </div>
      <div class="col-4 col-md-5 col-lg-7 col-xl-6 justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.microloanCustomerLoanLimit | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 col-md-3 col-lg-2 col-xl-3 d-flex justify-content-start">
        <span class="">Station: </span>
      </div>
      <div class="col-8 col-md-9 col-lg-10 col-xl-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.stationName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-8">
    <div class="row">
      <div class="col-4 col-lg-3 col-xl-2 d-flex justify-content-start">
        <span class="">Comment: </span>
      </div>
      <div class="col-8 col-lg-9 col-xl-10 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerComment }}
        </span>
      </div>
    </div>
  </div>
</div>
